var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDepart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6654 11.334L9.71536 10.4007L12.782 7.33398L9.71536 4.26732L10.6654 3.33398L14.6654 7.33398L10.6654 11.334ZM1.33203 12.6673V10.0007C1.33203 9.07843 1.65714 8.29243 2.30736 7.64265C2.95759 6.99287 3.74359 6.66776 4.66536 6.66732H8.78203L6.38203 4.26732L7.33203 3.33398L11.332 7.33398L7.33203 11.334L6.38203 10.4007L8.78203 8.00065H4.66536C4.10981 8.00065 3.63759 8.1951 3.2487 8.58398C2.85981 8.97287 2.66536 9.4451 2.66536 10.0007V12.6673H1.33203Z",
    fill: "#435869"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDepart);
export default __webpack_public_path__ + "static/media/icon-depart.1cb74dc9224c79b6277d3466d68e03c7.svg";
export { ForwardRef as ReactComponent };